import { useState, useEffect } from 'react';
import firebase from './../../../services/initFirebase';
import CityItem from './cityItem';
export default function ListCities() {
    const [cities, setCities] = useState([]);

    const fetchCities = () => {
        firebase.firestore().collection("cidades").onSnapshot((snapshot => {
            setCities([])
            snapshot.forEach((doc) => {
                setCities(cities => cities.concat(doc.data()));
            });
        }))
    }
    const listCities = cities.map((item, index) => (
        <CityItem key={item.name + " / " + index} data={item} />
    ))
    const control = 0;
    useEffect(() => {
        fetchCities();
    }, [control])
    return (
        <>
            {listCities}
        </>
    )
}